export default class Gtag {

    constructor() {
        window.dataLayer = window.dataLayer || [];
        this.analytics();
        this.ecommerce();
        this.registerEventHandler();
    }

    push() {
        window.dataLayer.push(arguments);
    }

    analytics() {
        this.push('js', new Date);
        this.push('config', document.head.querySelector('meta[name="gtag-id"]').content);
    }

    ecommerce() {
        let data = document.head.querySelector('meta[name="ecommerce-data"]').content;
        if (!data) {
            return;
        }
        this.push(JSON.parse(data));
    }

    registerEventHandler() {
        // EventHandler.listen('form-submitted', form => this.submitted(form));
        $(document).on('click', 'a[href^="mailto:"]', event => {
            const mailto = $(event.currentTarget).attr('href').split(':')[1] || '';
            this.push(
                'event',
                'contact',
                {
                    event_category: 'enquiries',
                    event_action: 'mailto',
                    event_label: 'click on "' + mailto + '" email address'
                }
            );
        });
        $(document).on('click', 'a[href^="tel:"]', event => {
            const tel = $(event.currentTarget).attr('href').split(':')[1] || '';
            this.push(
                'event',
                'contact',
                {
                    event_category: 'enquiries',
                    event_action: 'click-to-call',
                    event_label: 'click on "' + tel + '" telephone number'
                }
            );
        });
    }

    submitted(form) {
        // only tracks form submissions
        this.push(
            'event',
            'submit',
            {
                event_category: 'enquiries',
                event_label: form + ' form submission'
            }
        );
    }

}